import * as React from 'react';
import { Route } from 'react-router-dom';
import config from 'config';
import NotFound from '_containers/NotFound';
import accessibleProductForUser from '__common/utils/products';
const RedirectProtected: React.StatelessComponent<redirectProtectedComponentState> = ({ component: Component, isAuthenticated, user, dispatch, restrictedUrl, accessibleUrl=true, ...rest }) => {
  let { productId, projectId } = rest.computedMatch?.params;
  if(productId === 'nxt_horizon')
    productId = 'nxt_umount';
    if(productId === 'rm_gridflex_10')
    productId = 'rm_gridflex_10d';

  let isaccessibleUrl = accessibleUrl;
  if(restrictedUrl && !projectId) {
    isaccessibleUrl = accessibleProductForUser(productId);
  }

  const isLitePath = rest.path && (rest.path.startsWith('/lite/') || rest.path.startsWith('/project/lite/'));
  if (isLitePath && config.domainName !== 'localhost') {
    const liteApp = user && user.applicationList && user.applicationList.ubuilder_lite;
    const isUniracUser = !!(user && user.email && user.email.toLowerCase().endsWith('@unirac.com'));
    const hasLiteAccess = !!(liteApp && (user.isStaff || liteApp.has_access || liteApp.is_default)) || isUniracUser;
    if (!hasLiteAccess) {
      isaccessibleUrl = false;
    }
  }

  return (
  <Route
    {...rest}
    render={props => (
      isAuthenticated ? isaccessibleUrl ? <Component {...props} />: <NotFound /> :
      (
        window.location = config.domainName === 'localhost' ? config.ssoLogoutUrl : config.ssoLoginUrlWithNext + config.applicationUrl + props.location.pathname
      )
  )}
/>
);
}
export default RedirectProtected;
